import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Modal from './Modal';
import ContactForm from './ContactForm';
import { trackEvent } from '../utils/analytics';

const NEWSLETTER_URL = 'https://newsletter.alekhagopian.com';

const links = [
  { to: '/work', label: 'Work' },
  { to: '/apps', label: 'Apps' },
  { to: '/about', label: 'About' },
];

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const { pathname } = useLocation();

  // Close the mobile menu whenever the route changes, otherwise it stays open
  // over the page the visitor just navigated to.
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <>
      <header className="site-nav">
        <div className="site-nav-inner">
          <Link to="/" className="site-nav-brand">Alek Hagopian</Link>

          <button
            type="button"
            className="site-nav-toggle"
            aria-expanded={menuOpen}
            aria-controls="site-nav-menu"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setMenuOpen(open => !open)}
          >
            {menuOpen ? '✕' : '☰'}
          </button>

          <nav
            id="site-nav-menu"
            className={`site-nav-menu ${menuOpen ? 'is-open' : ''}`}
            aria-label="Main"
          >
            {links.map(link => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `site-nav-link ${isActive ? 'is-active' : ''}`
                }
              >
                {link.label}
              </NavLink>
            ))}

            <a
              href={NEWSLETTER_URL}
              className="site-nav-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent('newsletter_click', { location: 'nav' })}
            >
              Newsletter
              <span className="site-nav-external" aria-hidden="true">↗</span>
              <span className="sr-only">(opens in a new tab)</span>
            </a>

            <button
              type="button"
              className="btn btn-primary site-nav-cta"
              onClick={() => setShowContactModal(true)}
            >
              Get in touch
            </button>
          </nav>
        </div>
      </header>

      <Modal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
        title="Start a conversation"
      >
        <ContactForm onClose={() => setShowContactModal(false)} />
      </Modal>
    </>
  );
};

export default Nav;
